import { useContext, useEffect, useState } from 'react';
import NuevoStroLight from '../components/nuevoStro/Light/NuevoStroLight';
import NuevoStroDark from '../components/nuevoStro/Dark/NuevoStroDark';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Reclamo from './Reclamo';
import { ThemeContext } from '../context/Theme';
import { ActualizarSiniestroProvider } from '../context/ActualizarSiniestro';
import AiChatWidget from '../components/AiChatWidget/AiChatWidget';
export default function NuevoStro() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const id = useParams().id;
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem('id', id);
  }, []);
  const navigate = useNavigate();
  const [cookies] = useCookies(['user'], ['asignado']);
  const asignado = cookies.asignado;
  // Stro
  const [denuncia, setDenuncia] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [frente, setFrente] = useState({});
  const [sicobe, setSicobe] = useState([]);
  const [pagosAnteriores1, setPagosAnteriores1] = useState([]);
  const [cobert, setCobert] = useState('');
  const [carga2, setCarga2] = useState(false);
  const [estados, setEstados] = useState([]);
  const [estadosCodigos, setEstadosCodigos] = useState([]);
  const [carga3, setCarga3] = useState(false);
  const [planillaReclamos, setPlanillaReclamos] = useState([]);
  const [carga4, setCarga4] = useState(false);
  //reclamo
  const [reclamo3ro, setReclamo3ro] = useState([]);
  const [stro, setStro] = useState([]);
  const [valoresReclamos, setValoresReclamos] = useState([]);
  const [reclamoSeleccionado, setReclamoSeleccionado] = useState(0);
  const [terminoCargarTodoImportante, setTerminoCargarTodoImportante] = useState(false);
  //docs
  const [estadoDocs, setEstadoDocs] = useState({
    denunciaAdministrativa: 901,
    registro: 901,
    cedula: 901,
    presupuesto: 901,
    fotos: 901,
    cobertura: 901,
    vtv: 901,
    formulario08: 901,
    denunciaPolicial: 901,
    lesiones: 901,
    croquis: 901,
    cartaFranquicia: 901,
    danioPropiedad: 901,
    fotosAseguradoAGS: 901,
    noDestruccionTotal: 901,
  });
  const [obs, setObs] = useState({
    denunciaAdministrativa: '',
    registro: '',
    cedula: '',
    presupuesto: '',
    fotos: '',
    cobertura: '',
    vtv: '',
    formulario08: '',
    denunciaPolicial: '',
    lesiones: '',
    croquis: '',
    cartaFranquicia: '',
    danioPropiedad: '',
    fotosAseguradoAGS: '',
    noDestruccionTotal: '',
  });
  const [planilla, setPlanilla] = useState(0);
  // reclamoNuevaEstructura
  const [reclamos, setReclamos] = useState([]);
  const [reclamoSeleccionadoNuevo, setReclamoSeleccionadoNuevo] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // PRIMER BLOQUE
        const resDenuncia = await axios.get(`https://back.agsseguros.online/api/prueba/busquedaPrimerBloque/${id}`);
        setDenuncia(resDenuncia.data);
        const { nroStro, entryId } = resDenuncia.data;
        const baseUrl = nroStro
          ? `https://back.agsseguros.online/api/prueba/busquedaSegundoBloque/base/${nroStro}`
          : `https://back.agsseguros.online/api/prueba/busquedaSegundoBloque/base/entryId/${entryId}`;

        const detalleUrl = nroStro
          ? `https://back.agsseguros.online/api/prueba/busquedaSegundoBloque/detalle/${nroStro}`
          : `https://back.agsseguros.online/api/prueba/busquedaSegundoBloque/detalle/entryId/${entryId}`;

        const tercerBloqueUrl =
          cookies?.user?.depto === 'choques'
            ? `https://back.agsseguros.online/api/prueba/busquedaTercerBloqueChoques/${id}`
            : `https://back.agsseguros.online/api/prueba/busquedaTercerBloqueContractuales/${id}`;

        // BASE
        axios.get(baseUrl).then(resBase => {
          setReclamos(resBase.data);
          setReclamoSeleccionadoNuevo(0);

          if (cookies.user.id === 107 && resBase.data.every(r => r.estado !== 302 && r.estado !== 311)) {
            navigate('/');
          }

          // ARCHIVOS
          const ids = resBase.data.map(r => r.idReclamo);

          axios.post('https://back.agsseguros.online/api/documentosVpsReclamos/archivosReclamos', { ids }).then(resArchivos => {
            setReclamos(prev =>
              prev.map(r => ({
                ...r,
                reclamo3ro: {
                  ...r.reclamo3ro,
                  archivos: resArchivos.data[r.idReclamo] || {},
                },
              }))
            );
          });
        });

        // DETALLE
        axios.get(detalleUrl).then(resDetalle => {
          setReclamos(prev =>
            prev.map(r => {
              const detalle = resDetalle.data.find(d => d.id === r.id);
              if (!detalle) return r;
              const camposNuevos = Object.keys(detalle).filter(
                key =>
                  ![
                    'id',
                    'nroStro',
                    'idReclamo',
                    'idPlanillaReclamo',
                    'patenteAseg',
                    'patente3ro',
                    'estado',
                    'catStro',
                    'asignado',
                    'porcentaje',
                    'aceptacion',
                    'ordenDePago',
                    'monto',
                    'comercial',
                    'fRecRecibido',
                    'obs',
                    'f15',
                  ].includes(key)
              );

              const mergeDetalle = {};
              camposNuevos.forEach(key => (mergeDetalle[key] = detalle[key]));

              return { ...r, ...mergeDetalle };
            })
          );
        });

        // VALORES
        axios.get(`https://back.agsseguros.online/api/prueba/valoresEstadoDeUnStro/${id}`).then(resValoresReclamos => {
          setValoresReclamos(resValoresReclamos.data);
        });

        // TERCER BLOQUE
        axios.get(tercerBloqueUrl).then(resTercerBloque => {
          setDenuncia(prev => ({
            ...prev,
            ...resTercerBloque.data,
          }));

          setTerminoCargarTodoImportante(true);
        });

        // SICOBE

        axios.get(`https://back.agsseguros.online/api/prueba/tieneCobertura/${id}`).then(resSicobe => {
          setSicobe(resSicobe.data);

          const pagos = resSicobe.data.pagos || [];
          const arrayFechaLimite = resSicobe.data.fechaLimiteWe || [];
          const fechaStro = new Date(resSicobe.data.fechaStro);

          const pagosAnteriores = [];

          for (let i = 0; i < arrayFechaLimite.length; i++) {
            if (new Date(arrayFechaLimite[i]) < fechaStro) {
              pagosAnteriores.push(i);
            }
          }

          setPagosAnteriores1(pagosAnteriores);

          const totalImporteFechaStro = pagos
            .slice(0, pagosAnteriores.length)
            .map(item => parseFloat(item?.pga_importe) || 0)
            .reduce((acc, importe) => acc + importe, 0);

          const totalImporteEsperado = (parseFloat(pagos[0]?.pga_importe) || 0) * pagosAnteriores.length;

          if (pagos.length === 0) {
            setCobert('COBERTURA');
          } else if (pagos[0]?.pga_mp === 'TA') {
            setCobert('COBERTURA');
          } else if (totalImporteFechaStro !== totalImporteEsperado) {
            setCobert('EN REVISION');
          } else if (pagosAnteriores.length > 0) {
            const ultimoPagoAnterior = pagos[pagosAnteriores.length - 1];
            const pgaFechaAlta = new Date(ultimoPagoAnterior.pga_fliqags);
            const fechaLimite = new Date(arrayFechaLimite[pagosAnteriores.length - 1]);

            if (pgaFechaAlta <= fechaLimite) {
              setCobert('COBERTURA');
            } else if (fechaStro >= pgaFechaAlta) {
              setCobert('COBERTURA');
            } else {
              setCobert('EN REVISION');
            }
          } else {
            setCobert('EN REVISION');
          }

          setCarga3(true);
        });

        // FRENTE

        axios.get(`https://back.agsseguros.online/api/prueba/frente/${id}`).then(resFrente => {
          setFrente(resFrente.data);
          setCarga2(true);
        });

        // PLANILLA
        axios.get(`https://back.agsseguros.online/api/prueba/reclamo/${resDenuncia.data.id}`).then(resReclamo => {
          setPlanillaReclamos(resReclamo.data);
          setCarga4(true);
        });

        setCargando(true);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };

    fetchData();
  }, [id]);
  // render
  useEffect(() => {}, [theme]);
  useEffect(() => {
    if (location.search === '?mode=rec') {
      setPlanilla(1);
    }
  }, []);
  const [nuevoReclamo, setNuevoReclamo] = useState(0);
  const ESTADO_DOCS_BASE = {
    denunciaAdministrativa: 901,
    registro: 901,
    cedula: 901,
    presupuesto: 901,
    fotos: 901,
    cobertura: 901,
    vtv: 901,
    formulario08: 901,
    denunciaPolicial: 901,
    lesiones: 901,
    croquis: 901,
    danioPropiedad: 901,
    fotosAseguradoAGS: 901,
    noDestruccionTotal: 901,
    cartaFranquicia: 901,
  };
  const OBS_BASE = {
    denunciaAdministrativa: '',
    registro: '',
    cedula: '',
    presupuesto: '',
    fotos: '',
    cobertura: '',
    vtv: '',
    formulario08: '',
    denunciaPolicial: '',
    lesiones: '',
    croquis: '',
    danioPropiedad: '',
    fotosAseguradoAGS: '',
    noDestruccionTotal: '',
    cartaFranquicia: '',
  };
  useEffect(() => {
    const docs = reclamos[reclamoSeleccionadoNuevo]?.reclamo3ro?.docs;
    if (!docs) {
      setObs(OBS_BASE);
      setEstadoDocs(ESTADO_DOCS_BASE);
      return;
    }
    const nuevosEstados = { ...ESTADO_DOCS_BASE };
    const nuevasObs = { ...OBS_BASE };
    Object.keys(ESTADO_DOCS_BASE).forEach(campo => {
      const campoObs = 'obs' + campo.charAt(0).toUpperCase() + campo.slice(1);
      const campoEstado = 'estado' + campo.charAt(0).toUpperCase() + campo.slice(1);
      nuevasObs[campo] = docs[campoObs] ?? '';
      nuevosEstados[campo] = docs[campoEstado] ?? 901;
    });
    setObs(nuevasObs);
    setEstadoDocs(nuevosEstados);
  }, [reclamoSeleccionadoNuevo, reclamos]);

  if (planilla && !reclamos[reclamoSeleccionadoNuevo]?.idReclamo) {
    const primerValido = reclamos.findIndex(r => r.idReclamo != null);
    if (primerValido !== -1) {
      setReclamoSeleccionadoNuevo(primerValido);
    }
  }
  return (
    <ActualizarSiniestroProvider denuncia={denuncia} reclamos={reclamos}>
      <>
        {planilla === 0 ? (
          theme === 1 ? (
            <NuevoStroLight
              cargando={cargando}
              stro={denuncia}
              carga3={carga3}
              estados={estados}
              estadosCodigos={estadosCodigos}
              frente={frente}
              sicobe={sicobe}
              reclamo={planillaReclamos}
              planillaReclamos={planillaReclamos}
              carga2={carga2}
              pagosAnteriores={pagosAnteriores1}
              cobert={cobert}
              carga4={carga4}
              setPlanilla={setPlanilla}
              planilla={planilla}
              valoresReclamos={valoresReclamos}
              reclamoSeleccionado={reclamoSeleccionado}
              setReclamoSeleccionado={setReclamoSeleccionado}
              reclamos={reclamos}
              reclamoSeleccionadoNuevo={reclamoSeleccionadoNuevo}
              setReclamoSeleccionadoNuevo={setReclamoSeleccionadoNuevo}
              nuevoReclamo={nuevoReclamo}
              setNuevoReclamo={setNuevoReclamo}
              terminoCargarTodoImportante={terminoCargarTodoImportante}
            />
          ) : (
            <NuevoStroDark
              cargando={cargando}
              stro={denuncia}
              carga3={carga3}
              estados={estados}
              estadosCodigos={estadosCodigos}
              frente={frente}
              sicobe={sicobe}
              reclamo={planillaReclamos}
              planillaReclamos={planillaReclamos}
              carga2={carga2}
              pagosAnteriores={pagosAnteriores1}
              cobert={cobert}
              carga4={carga4}
              setPlanilla={setPlanilla}
              planilla={planilla}
              valoresReclamos={valoresReclamos}
              reclamoSeleccionado={reclamoSeleccionado}
              setReclamoSeleccionado={setReclamoSeleccionado}
              reclamos={reclamos}
              reclamoSeleccionadoNuevo={reclamoSeleccionadoNuevo}
              setReclamoSeleccionadoNuevo={setReclamoSeleccionadoNuevo}
              nuevoReclamo={nuevoReclamo}
              setNuevoReclamo={setNuevoReclamo}
              terminoCargarTodoImportante={terminoCargarTodoImportante}
            />
          )
        ) : (
          <Reclamo
            reclamos={reclamos.filter(r => r.idReclamo !== null)}
            reclamoSeleccionadoNuevo={reclamos[reclamoSeleccionadoNuevo]}
            setReclamoSeleccionadoNuevo={setReclamoSeleccionadoNuevo}
            nuevoReclamo={nuevoReclamo}
            setNuevoReclamo={setNuevoReclamo}
            reclamo={reclamo3ro}
            stro={denuncia}
            planilla={planilla}
            setPlanilla={setPlanilla}
            denuncia={denuncia}
            carga4={carga4}
            reclamoPanel={planillaReclamos}
            theme={theme}
            estadoDocs={estadoDocs}
            obs={obs}
            setEstadoDocs={setEstadoDocs}
            setObs={setObs}
            cargando={cargando}
          />
        )}
        <AiChatWidget denuncia={denuncia} estados={estados} reclamos={reclamos} reclamoSeleccionado={reclamos[reclamoSeleccionadoNuevo]} />
      </>
    </ActualizarSiniestroProvider>
  );
}
